import React from 'react';
import { useLocation } from 'wouter';
import { useIsDesktop } from '../hooks/useMediaQuery';
import OrganizerLayout from './OrganizerLayout';
import OrganizerDesktopLayout from './OrganizerDesktopLayout';
import TouristDesktopLayout from './TouristDesktopLayout';

interface LayoutWrapperProps {
  children: React.ReactNode;
  mode: 'organizer' | 'tourist';
}

/**
 * LayoutWrapper - Sélectionne le layout approprié selon le mode et la taille d'écran
 *
 * Pour l'organisateur:
 * - Desktop (≥1024px): OrganizerDesktopLayout (3 colonnes)
 * - Mobile (<1024px): OrganizerLayout existant (bottom nav)
 *
 * Pour le touriste:
 * - Desktop (≥1024px): TouristDesktopLayout (FABs flottants) sauf pour /favorites
 * - Desktop /favorites: FavoritesPage avec layout 2 colonnes dédié
 * - Mobile (<1024px): Layout existant avec children
 */
const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children, mode }) => {
  const isDesktop = useIsDesktop();
  const [location] = useLocation();

  if (mode === 'organizer') {
    if (isDesktop) {
      // Desktop: Le layout 3 colonnes gère tout le routing interne
      return <OrganizerDesktopLayout />;
    } else {
      // Mobile: Layout existant avec children
      return <OrganizerLayout>{children}</OrganizerLayout>;
    }
  }

  // Mode touriste
  if (isDesktop) {
    // Sur desktop, /favorites affiche la page dédiée (pas le TouristDesktopLayout)
    if (location.startsWith('/favorites')) {
      return <>{children}</>;
    }

    // Desktop: Layout flottant touriste (FABs/panels)
    return <TouristDesktopLayout />;
  }

  // Mobile: Layout existant avec children
  return <>{children}</>;
};

export default LayoutWrapper;
